/* Fable Cart: owned cart drawer for Fable Beard Co (replaces Monster Cart Upsell). No dependencies. */
(function () {
  'use strict';
  if (window.__fableCartLoaded) return;
  window.__fableCartLoaded = true;
  var cfgEl = document.getElementById('FableCartConfig');
  var el = document.getElementById('FableCart');
  if (!cfgEl || !el) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { console.error('Fable Cart config', e); return; }
  var T = C.t || {};
  function tx(k, d) { return T[k] == null || T[k] === '' ? d : T[k]; }

  var ROOT = (C.root || '/').replace(/\/?$/, '/');
  var nativeFetch = window.fetch.bind(window);
  var state = { cart: C.cart, open: false, busy: false, recs: [], recsFor: null, subMode: C.subDefault === 'monthly' ? 'monthly' : 'yearly', subPick: {}, planInfo: {}, lastFocus: null, giftSync: false };
  var $ = function (s, r) { return (r || el).querySelector(s); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  // Start/end dates are typed in shop time ("2026-11-27" or "2026-11-27 18:00"). A date-only end runs through that whole day.
  function when(str, isEnd) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/); if (!m) return null;
    var tz = String(C.tz || '+0000').replace(/^([+-]\d{2})(\d{2})$/, '$1:$2');
    var d = new Date(m[1] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[3]).slice(-2) + 'T' + ('0' + (m[4] || '0')).slice(-2) + ':' + (m[5] || '00') + ':00' + tz);
    if (isNaN(d)) return null;
    return isEnd && !m[4] ? new Date(d.getTime() + 864e5) : d;
  }
  function isLive(t) { var now = Date.now(), a = when(t.start), b = when(t.end, true); return (!a || now >= a) && (!b || now < b); }
  var allTiers = (C.tiers || []).filter(function (t) { return t && t.at > 0; }).sort(function (a, b) { return a.at - b.at; });
  var tiers = allTiers.filter(isLive);
  var giftIds = allTiers.filter(function (t) { return t.kind === 'gift'; }).map(function (t) { return t.variant; });

  // ---------- money ----------
  function money(cents) {
    var n = (cents || 0) / 100;
    var fmt = C.money || '${{amount}}';
    var withC = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noC = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return noC;
      if (k === 'amount_with_comma_separator') return withC.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
      return withC;
    }).replace('.00', '');
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160); }

  // ---------- cart api ----------
  function api(path, body) {
    var opt = { method: body ? 'POST' : 'GET', headers: { Accept: 'application/json', 'X-Fable-Cart': '1' }, credentials: 'same-origin' };
    if (body) { opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return nativeFetch(ROOT + path, opt).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Cart error'); e.data = j; throw e; } return j; });
    });
  }
  function load() { return api('cart.js').then(function (c) { state.cart = c; return c; }); }

  function isGift(it) { return giftIds.indexOf(it.variant_id) > -1 || (it.properties && (it.properties._fable_gift || it.properties._monster_free_gift != null)); }
  function isSub(it) { return !!it.selling_plan_allocation; }
  function progressTotal(c) {
    var t = c.total_price;
    c.items.forEach(function (it) { if (isGift(it)) t -= it.final_line_price; else if (!C.countSubs && isSub(it)) t -= it.final_line_price; });
    return Math.max(0, t);
  }

  // Keep free gifts in step with the cart total. Returns true when it changed the cart.
  function syncGifts() {
    if (state.giftSync || !giftIds.length) return Promise.resolve(false);
    tiers = allTiers.filter(isLive);
    var c = state.cart, total = progressTotal(c), ops = [];
    var paid = c.items.filter(function (it) { return !isGift(it); }).length;
    allTiers.forEach(function (t) {
      if (t.kind !== 'gift') return;
      var lines = c.items.filter(function (it) { return it.variant_id === t.variant; });
      var want = isLive(t) && paid > 0 && total >= t.at;
      if (want && !lines.length) ops.push(['add', { items: [{ id: t.variant, quantity: 1, properties: { _fable_gift: '1' } }] }]);
      lines.forEach(function (it, i) {
        if (!want || i > 0) ops.push(['change', { id: it.key, quantity: 0 }]);
        else if (it.quantity > 1) ops.push(['change', { id: it.key, quantity: 1 }]);
      });
    });
    // Old Monster gift lines that no tier owns any more.
    c.items.forEach(function (it) { if (it.properties && it.properties._monster_free_gift != null && giftIds.indexOf(it.variant_id) < 0) ops.push(['change', { id: it.key, quantity: 0 }]); });
    if (!ops.length) return Promise.resolve(false);
    state.giftSync = true;
    return ops.reduce(function (p, op) { return p.then(function () { return api('cart/' + op[0] + '.js', op[1]); }); }, Promise.resolve())
      .catch(function (e) { console.warn('Fable Cart gift', e); })
      .then(load).then(function () { state.giftSync = false; return true; }, function () { state.giftSync = false; return false; });
  }

  // ---------- render ----------
  function render() {
    tiers = allTiers.filter(isLive);
    var c = state.cart;
    var items = c.items || [];
    $('[data-fc-count]').textContent = c.item_count ? '(' + c.item_count + ')' : '';
    renderTiers(c);
    var body = $('[data-fc-body]');
    if (!items.length) { body.innerHTML = renderEmpty(); $('[data-fc-foot]').hidden = true; loadEmpty(); return updateBubble(c); }
    $('[data-fc-foot]').hidden = false;
    el.classList.toggle('has-sub', items.some(isSub));
    var ordered = items.filter(function (it) { return !isGift(it); }).concat(items.filter(isGift));
    var h = '<ul class="fc__items" role="list">' + ordered.map(renderLine).join('') + '</ul>';
    var recsHtml = '<section class="fc__recs" data-fc-recs>' + renderRecs() + '</section>';
    h += C.order === 'sub_first' ? renderSubCard(c) + recsHtml : recsHtml + renderSubCard(c);
    if (C.giftNote) h += '<details class="fc__note"' + (c.note ? ' open' : '') + '><summary>' + esc(C.giftNote) + '</summary><textarea maxlength="500" data-fc-note placeholder="' + esc(tx('notePh', '')) + '">' + esc(c.note || '') + '</textarea></details>';
    var trust = (C.trust || []).filter(Boolean);
    if (C.showTrust !== false && trust.length) h += '<ul class="fc__trust" role="list">' + trust.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>';
    body.innerHTML = h;
    renderSummary(c);
    updateBubble(c);
    loadRecs();
    loadPlans();
    shipCheck();
  }

  function renderTiers(c) {
    var box = $('[data-fc-tiers]');
    if (C.showTiers === false || !tiers.length) { box.innerHTML = ''; return; }
    var total = progressTotal(c), max = tiers[tiers.length - 1].at;
    var next = tiers.filter(function (t) { return total < t.at; })[0];
    var msg = next
      ? 'You’re <b>' + money(next.at - total) + '</b> away from <b>' + esc(next.label) + '</b>'
      : '<b>' + esc(tx('unlocked', 'All rewards unlocked!')) + '</b> ' + esc(tiers.map(function (t) { return t.short; }).join(' + '));
    var pct = Math.min(100, Math.round(total / max * 100));
    box.innerHTML = '<p class="fc__tmsg">' + msg + '</p><div class="fc__bar" role="progressbar" aria-valuemin="0" aria-valuemax="' + (max / 100) + '" aria-valuenow="' + (total / 100) + '" aria-label="Rewards progress"><span class="fc__fill" style="width:' + pct + '%"></span>' +
      tiers.map(function (t) {
        var at = Math.round(t.at / max * 100), done = total >= t.at;
        return '<span class="fc__dot' + (done ? ' is-done' : '') + '" style="left:' + at + '%"><i>' + (done ? '✓' : (t.kind === 'ship' ? '\u{1F69A}' : '\u{1F381}')) + '</i><em><span class="fc__dl">' + esc(t.short) + '<br></span>' + money(t.at) + '</em></span>';
      }).join('') + '</div>';
  }

  function nameParts(title) {
    var p = String(title || '').split(' - ');
    if (p.length >= 3) return { main: p[0] + ' – ' + p[1], sub: p.slice(2).join(' - ') };
    return { main: title, sub: '' };
  }

  function renderLine(it) {
    var gift = isGift(it), sp = it.selling_plan_allocation;
    var np = nameParts(it.product_title);
    var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return o.value; }).join(' / ');
    var props = Object.keys(it.properties || {}).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; }).map(function (k) { return esc(k) + ': ' + esc(it.properties[k]); }).join('<br>');
    var price = it.original_line_price !== it.final_line_price
      ? '<s>' + money(it.original_line_price) + '</s> <b>' + money(it.final_line_price) + '</b>'
      : '<b>' + (gift ? 'FREE' : money(it.final_line_price)) + '</b>';
    var plan = '';
    if (sp) {
      var per = sp.per_delivery_price && sp.per_delivery_price !== sp.price ? ' · ' + money(sp.per_delivery_price) + '/delivery' : (/year/i.test(sp.selling_plan.name) ? ' · billed once a year (' + money(Math.round(sp.price / 12)) + '/mo)' : '');
      plan = '<span class="fc__plan">↻ ' + esc(sp.selling_plan.name) + per + '</span>';
    }
    var disc = (it.line_level_discount_allocations || []).map(function (d) { return '<span class="fc__disc">' + esc(d.discount_application.title) + ' (−' + money(d.amount) + ')</span>'; }).join('');
    var subToggle = gift ? '' : '<span data-fc-plan="' + it.key + '"></span>';
    var qty = gift
      ? '<span class="fc__lock">' + esc(tx('giftLine', 'Unlocked reward')) + '</span>'
      : '<div class="fc__qty"><button type="button" data-fc-qty="' + it.key + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease ' + esc(it.product_title) + '">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-fc-qty="' + it.key + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase ' + esc(it.product_title) + '">+</button></div>' +
        '<button type="button" class="fc__rm" data-fc-qty="' + it.key + '" data-q="0">Remove</button>';
    return '<li class="fc__line' + (gift ? ' is-gift' : '') + '">' +
      '<a class="fc__img" href="' + (gift ? '#' : esc(it.url)) + '" tabindex="-1">' + (it.image ? '<img src="' + esc(img(it.image, 180)) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</a>' +
      '<div class="fc__info"><a class="fc__name" href="' + (gift ? '#' : esc(it.url)) + '">' + esc(np.main) + '</a>' +
      (np.sub ? '<span class="fc__scent">' + esc(np.sub) + '</span>' : '') +
      (opts ? '<span class="fc__opt">' + esc(opts) + '</span>' : '') + (props ? '<span class="fc__opt">' + props + '</span>' : '') +
      plan + disc + subToggle + '<div class="fc__row">' + qty + '</div></div>' +
      '<div class="fc__price">' + price + '</div></li>';
  }

  function renderSummary(c) {
    var h = '';
    (c.cart_level_discount_applications || []).forEach(function (d) { h += '<div class="fc__sumrow fc__save"><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>'; });
    if (c.total_discount > 0) h += '<div class="fc__sumrow fc__save"><span>You’re saving</span><span>' + money(c.total_discount) + '</span></div>';
    h += '<div class="fc__sumrow fc__total"><span>' + esc(tx('subtotal', 'Subtotal')) + '</span><span>' + money(c.total_price) + '</span></div>';
    $('[data-fc-sum]').innerHTML = h;
    var fine = [];
    if (C.points > 0) {
      var base = 0; c.items.forEach(function (it) { if (!isGift(it)) base += it.final_line_price; });
      var pts = Math.floor(base / 100) * C.points;
      if (pts > 0) fine.push('You’ll earn <b>' + pts.toLocaleString() + ' ' + esc(C.pointsName || 'points') + '</b> on this order');
    }
    if (tx('tax', '')) fine.push(esc(tx('tax', '')));
    $('[data-fc-fine]').innerHTML = fine.join('<br>');
  }

  // ---------- subscription upsell (monthly Fable Army / yearly prepaid) ----------
  function armyDefault(c) {
    var a = C.army; if (!a || !a.variants.length) return null;
    if (a.default) { var d = a.variants.filter(function (v) { return v.title.toLowerCase() === String(a.default).trim().toLowerCase(); })[0]; if (d) return d.id; }
    var types = c.items.filter(function (it) { return !isGift(it) && !isSub(it); }).map(function (it) { return it.product_type || ''; });
    for (var i = 0; i < types.length; i++) {
      var t = types[i].replace(/^Beard /, '').toLowerCase();
      var m = a.variants.filter(function (v) { return v.title.toLowerCase() === types[i].toLowerCase() || v.title.toLowerCase() === t || v.title.toLowerCase() === ('beard ' + t); })[0];
      if (m) return m.id;
    }
    return a.variants[0].id;
  }
  function renderSubCard(c) {
    if (!C.subCard) return '';
    var a = C.army, y = C.yearly || [];
    var hasArmy = a && c.items.some(function (it) { return it.product_id === a.product && isSub(it); });
    // Any yearly plan already in the cart (from the yearly / Inner Circle page, the payment-plan version, or this card) hides the whole card.
    var hasYear = c.items.some(function (it) { return y.some(function (v) { return v.product === it.product_id; }) || /yearly/i.test(it.product_title || '') || (isSub(it) && /year/i.test(it.selling_plan_allocation.selling_plan.name || '')); });
    var canM = a && a.variants.length && !hasArmy && !hasYear, canY = y.length && !hasYear;
    if (!canM && !canY) return '';
    var mode = state.subMode;
    if (mode === 'monthly' && !canM) mode = 'yearly';
    if (mode === 'yearly' && !canY) mode = 'monthly';
    var tabs = canM && canY ? '<div class="fc__seg" role="tablist" aria-label="Subscription length">' +
      '<button type="button" role="tab" aria-selected="' + (mode === 'yearly') + '" data-fc-mode="yearly">' + esc(tx('tabY', 'Yearly')) + (tx('tabYs', '') ? ' <small>' + esc(tx('tabYs', '')) + '</small>' : '') + '</button>' +
      '<button type="button" role="tab" aria-selected="' + (mode === 'monthly') + '" data-fc-mode="monthly">' + esc(tx('tabM', 'Monthly')) + (tx('tabMs', '') ? ' <small>' + esc(tx('tabMs', '')) + '</small>' : '') + '</button></div>' : '';
    var inner;
    if (mode === 'monthly') {
      var pick = state.subPick.m || armyDefault(c);
      var v = a.variants.filter(function (x) { return x.id === pick; })[0] || a.variants[0];
      inner = '<div class="fc__subrow"><img src="' + esc(v.image || a.image) + '" alt="" width="72" height="72" loading="lazy">' +
        '<div><b class="fc__subt">' + esc(a.title) + '</b><p>' + esc(a.blurb) + '</p>' +
        '<label class="fc__sel"><span class="fc__vh">Choose your monthly box</span><select data-fc-subpick="m">' + a.variants.map(function (x) { return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(x.title) + ' · ' + money(x.price) + '/mo</option>'; }).join('') + '</select></label></div></div>' +
        '<button type="button" class="fc__subadd" data-mode="monthly" data-fc-subadd="' + v.id + '" data-plan="' + v.plan + '">Add · ' + money(v.price) + '/mo</button>';
    } else {
      // One offer only: the first yearly plan (Ultimate / Inner Circle).
      var yv = y[0];
      inner = '<div class="fc__subrow"><img src="' + esc(yv.image) + '" alt="" width="72" height="72" loading="lazy">' +
        '<div><b class="fc__subt">' + esc(C.yearlyTitle || 'Go yearly') + '</b><p>' + esc(yv.blurb) + '</p>' +
        '<p class="fc__subsell">' + (tx('ySave', '') ? '<span class="fc__savepill">' + esc(tx('ySave', '')) + '</span>' : '') + '<span class="fc__perday">Less than ' + money(Math.ceil(yv.price / 365 / 50) * 50) + '/day</span></p>' +
        '</div></div>' +
        '<button type="button" class="fc__subadd is-gold" data-mode="yearly" data-fc-subadd="' + yv.id + '" data-plan="' + yv.plan + '">Add yearly · ' + money(yv.price) + '</button>';
    }
    return '<section class="fc__sub" aria-label="Subscribe and never run out"><h3 class="fc__h">' + esc(tx('subHeading', 'Never run out')) + '</h3>' + tabs + inner + '</section>';
  }

  // Per-line subscribe toggle, only for products that sell with a selling plan themselves.
  function loadPlans() {
    state.cart.items.forEach(function (it) {
      if (isGift(it)) return;
      var h = it.handle; if (!h) return;
      if (state.planInfo[h] === undefined) {
        state.planInfo[h] = null;
        nativeFetch(ROOT + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          state.planInfo[h] = p ? { groups: p.selling_plan_groups || [], req: !!p.requires_selling_plan, variants: p.variants || [] } : false;
          paintPlans();
        }).catch(function () { state.planInfo[h] = false; });
      }
    });
    paintPlans();
  }
  function paintPlans() {
    state.cart.items.forEach(function (it) {
      var slot = el.querySelector('[data-fc-plan="' + CSS.escape(it.key) + '"]'); if (!slot) return;
      var info = state.planInfo[it.handle]; if (!info || !info.groups.length || info.req) { slot.innerHTML = ''; return; }
      var v = info.variants.filter(function (x) { return x.id === it.variant_id; })[0]; if (!v || !v.selling_plan_allocations || !v.selling_plan_allocations.length) { slot.innerHTML = ''; return; }
      if (it.selling_plan_allocation) { slot.innerHTML = '<button type="button" class="fc__plantog" data-fc-setplan="' + it.key + '" data-plan="">Switch to one-time</button>'; return; }
      var best = v.selling_plan_allocations.slice().sort(function (a, b) { return a.price - b.price; })[0];
      var save = v.price > best.price ? Math.round((1 - best.price / v.price) * 100) : 0;
      slot.innerHTML = '<button type="button" class="fc__plantog is-on" data-fc-setplan="' + it.key + '" data-plan="' + best.selling_plan_id + '">↻ Subscribe' + (save ? ' & save ' + save + '%' : '') + '</button>';
    });
  }

  // ---------- upsells ----------
  // Sources (Theme settings > Fable Cart > Upsell source):
  //   shopify    = Search & Discovery complementary picks + Shopify "related", same character first
  //   character  = only the same character's other products
  //   collection = products from the collection you pick
  function charOf(t) { return String(t || '').split(' - ')[0].trim().toLowerCase(); }
  function cents(x) { return x == null || x === '' ? 0 : (typeof x === 'string' ? Math.round(parseFloat(x) * 100) : x); }
  function norm(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    var im = p.featured_image; if (im && typeof im === 'object') im = im.src || im.url;
    if (!im && p.images && p.images[0]) im = p.images[0].src || p.images[0];
    if (!im && p.image) im = typeof p.image === 'object' ? p.image.src || p.image.url : p.image;
    return { id: p.id, title: p.title, handle: p.handle, url: p.url || (ROOT + 'products/' + p.handle), image: im, type: p.type || p.product_type || '',
      req: !!p.requires_selling_plan, v: v ? { id: v.id, price: cents(v.price), compare: cents(v.compare_at_price) } : null };
  }
  function getJSON(u) { return nativeFetch(u, { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function viaShopify(base) {
    var q = function (intent) { return getJSON(ROOT + 'recommendations/products.json?product_id=' + base.product_id + '&limit=10&intent=' + intent); };
    return Promise.all([q('complementary'), q('related')]).then(function (rs) {
      var out = []; rs.forEach(function (r) { ((r && r.products) || []).forEach(function (p) { out.push(norm(p)); }); }); return out;
    });
  }
  function viaCharacter(base) {
    var name = String(base.product_title || '').split(' - ')[0].trim();
    if (!name || name === base.product_title) return viaShopify(base);
    return getJSON(ROOT + 'search/suggest.json?q=' + encodeURIComponent(name) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title').then(function (j) {
      var hs = (((j || {}).resources || {}).results || {}).products || [];
      hs = hs.filter(function (p) { return charOf(p.title) === name.toLowerCase(); }).map(function (p) { return p.handle; });
      return Promise.all(hs.map(function (h) { return getJSON(ROOT + 'products/' + encodeURIComponent(h) + '.js'); }));
    }).then(function (ps) { var out = (ps || []).filter(Boolean).map(norm); return out.length ? out : viaShopify(base); });
  }
  function viaCollection() {
    if (!C.upsellCollection) return Promise.resolve([]);
    return getJSON(ROOT + 'collections/' + encodeURIComponent(C.upsellCollection) + '/products.json?limit=30').then(function (j) { return ((j && j.products) || []).map(norm); });
  }
  function loadRecs() {
    if (!C.upsells) return;
    // Shopify lists the newest line first, so [0] is the item the shopper just added.
    var base = state.cart.items.filter(function (it) { return !isGift(it) && !isSub(it); })[0];
    var src = C.upsellSource || 'shopify';
    if (!base && src !== 'collection') { state.recs = []; paintRecs(); return; }
    var key = src + ':' + (base ? base.product_id : '');
    if (state.recsFor === key) return paintRecs();
    state.recsFor = key;
    var ch = base ? charOf(base.product_title) : '';
    (src === 'collection' ? viaCollection() : src === 'character' ? viaCharacter(base) : viaShopify(base)).then(function (list) {
      if (state.recsFor !== key) return;
      var seen = {};
      list = list.filter(function (p) { if (!p || seen[p.id] || !p.v || p.req || /free_gift/i.test(p.type) || p.v.price <= 0) return false; seen[p.id] = 1; return true; });
      if (src !== 'collection') list.sort(function (a, b) { return (charOf(b.title) === ch) - (charOf(a.title) === ch); });
      state.recs = list; state.recsChar = ch;
      paintRecs();
    });
  }
  function renderRecs() {
    var inCart = {}; state.cart.items.forEach(function (it) { inCart[it.product_id] = 1; });
    var list = state.recs.filter(function (p) { return !inCart[p.id]; }).slice(0, Math.max(1, C.upsellMax || 6));
    if (!list.length) return '';
    var same = state.recsChar && list.filter(function (p) { return charOf(p.title) === state.recsChar; }).length >= 2;
    var title = same && C.setTitle ? esc(C.setTitle.replace(/\{character\}/gi, list[0].title.split(' - ')[0])) : esc(C.upsellTitle || 'Pairs well with your order');
    return '<h3 class="fc__h">' + title + '</h3><div class="fc__rail">' + list.map(function (p) {
      var v = p.v;
      var np = nameParts(p.title);
      return '<div class="fc__card"><a href="' + esc(p.url) + '" tabindex="-1">' + (p.image ? '<img src="' + esc(img(p.image, 220)) + '" alt="" loading="lazy" width="110" height="110">' : '') + '</a>' +
        '<span class="fc__cn">' + esc(np.sub ? np.main.split(' – ')[1] || np.main : np.main) + '</span>' + (np.sub ? '<span class="fc__cs">' + esc(np.main.split(' – ')[0]) + '</span>' : '') +
        '<span class="fc__cp">' + (v.compare > v.price ? '<s>' + money(v.compare) + '</s> ' : '') + money(v.price) + '</span>' +
        '<button type="button" data-fc-add="' + v.id + '" aria-label="Add ' + esc(p.title) + '">+ Add</button></div>';
    }).join('') + '</div>';
  }
  function paintRecs() { var b = $('[data-fc-recs]'); if (b) b.innerHTML = renderRecs(); }

  // ---------- theme editor only: does the bar's free-shipping amount match Shopify's shipping? ----------
  var shipChecked = null;
  function shipCheck() {
    var on = (window.Shopify && window.Shopify.designMode) || /[?&]fc_check=1/.test(location.search);
    var box = $('[data-fc-warn]');
    var ship = allTiers.filter(function (t) { return t.kind === 'ship'; })[0];
    if (!box) return;
    if (!on || !ship || !state.cart.item_count) { box.hidden = true; return; }
    var key = state.cart.total_price + ':' + ship.at; if (shipChecked === key) return; shipChecked = key;
    var q = 'shipping_address[zip]=37064&shipping_address[country]=United%20States&shipping_address[province]=Tennessee';
    var total = progressTotal(state.cart), expectFree = total >= ship.at;
    nativeFetch(ROOT + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST', headers: { Accept: 'application/json' } }).then(function () {
      var tries = 0;
      return (function poll() {
        return getJSON(ROOT + 'cart/async_shipping_rates.json?' + q).then(function (j) {
          if (j && j.shipping_rates) return j.shipping_rates;
          if (++tries > 8) return null;
          return new Promise(function (r) { setTimeout(r, 700); }).then(poll);
        });
      })();
    }).then(function (rates) {
      if (!rates) return;
      var hasFree = rates.some(function (r) { return parseFloat(r.price) === 0; });
      box.hidden = false;
      if (hasFree === expectFree) { box.className = 'fc__warn is-ok'; box.textContent = 'Editor check: free shipping matches Shopify for a ' + money(total) + ' cart.'; return; }
      box.className = 'fc__warn';
      box.textContent = 'Editor check: the bar says free shipping at ' + money(ship.at) + ', but Shopify ' + (hasFree ? 'already gives' : 'does not give') + ' free shipping on this ' + money(total) + ' cart. Make Settings → Shipping and delivery match the bar.';
    }).catch(function () {});
  }

  // ---------- empty cart ----------
  function renderEmpty() {
    var tease = tiers.length ? '<p class="fc__tease">' + tiers.map(function (t) { return esc(t.short) + ' at ' + money(t.at); }).join(' · ') + '</p>' : '';
    return '<div class="fc__empty"><p class="fc__et">' + esc(C.emptyTitle || 'Your cart is empty') + '</p>' + tease + '<div data-fc-emptyrecs></div><a class="fc__shop" href="' + ROOT + 'collections/all">Shop all</a></div>';
  }
  var emptyCache = null;
  function loadEmpty() {
    if (!C.emptyCollection) return;
    var put = function (ps) {
      var b = $('[data-fc-emptyrecs]'); if (!b || !ps.length) return;
      b.innerHTML = '<h3 class="fc__h">' + esc(tx('emptyRecs', 'Best sellers')) + '</h3><div class="fc__rail">' + ps.slice(0, 6).map(function (p) {
        var n = norm(p); if (!n.v) return '';
        var np = nameParts(n.title);
        return '<div class="fc__card"><a href="' + esc(n.url) + '" tabindex="-1">' + (n.image ? '<img src="' + esc(img(n.image, 220)) + '" alt="" loading="lazy" width="110" height="110">' : '') + '</a><span class="fc__cn">' + esc(np.main) + '</span><span class="fc__cp">' + money(n.v.price) + '</span><button type="button" data-fc-add="' + n.v.id + '">+ Add</button></div>';
      }).join('') + '</div>';
    };
    if (emptyCache) return put(emptyCache);
    nativeFetch(ROOT + 'collections/' + encodeURIComponent(C.emptyCollection) + '/products.json?limit=8').then(function (r) { return r.json(); }).then(function (j) {
      emptyCache = (j.products || []).filter(function (p) { return p.variants && p.variants.some(function (v) { return v.available; }); }); put(emptyCache);
    }).catch(function () {});
  }

  // ---------- header count bubble ----------
  function updateBubble(c) {
    var b = document.getElementById('cart-icon-bubble'); if (!b) return;
    var n = b.querySelector('.cart-count-bubble span[aria-hidden]');
    if (n && c.item_count) { n.textContent = c.item_count < 100 ? c.item_count : ''; return; }
    nativeFetch(ROOT + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var html = j['cart-icon-bubble']; if (!html) return;
      var d = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (d) b.innerHTML = d.innerHTML;
    }).catch(function () {});
  }

  // ---------- open / close ----------
  function open() {
    if (state.open) return;
    state.open = true; state.lastFocus = document.activeElement;
    el.hidden = false;
    void el.offsetWidth; // start the slide-in without waiting for an animation frame
    el.classList.add('is-open');
    document.documentElement.classList.add('fc-lock');
    setTimeout(function () { var p = $('.fc__panel'); p && p.focus(); }, 60);
    track('Viewed Cart');
  }
  function close() {
    if (!state.open) return;
    state.open = false; el.classList.remove('is-open');
    document.documentElement.classList.remove('fc-lock');
    setTimeout(function () { if (!state.open) el.hidden = true; }, 300);
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus();
  }
  function say(t) { var l = $('[data-fc-live]'); l.textContent = ''; setTimeout(function () { l.textContent = t; }, 30); }

  // ---------- refresh ----------
  var refreshT = null, wantOpen = false;
  // now=true runs at once (our own adds/changes); otherwise a short debounce merges bursts from other apps.
  function refresh(openAfter, now) {
    if (openAfter) wantOpen = true;
    clearTimeout(refreshT);
    return new Promise(function (res) {
      var run = function () {
        load().then(syncGifts).then(function () {
          render();
          if (wantOpen && location.pathname !== ROOT + 'cart') open();
          wantOpen = false; res(state.cart);
          document.dispatchEvent(new CustomEvent('fable:cart', { detail: state.cart }));
        }).catch(function (e) { console.error('Fable Cart', e); res(state.cart); });
      };
      if (now) run(); else refreshT = setTimeout(run, 40);
    });
  }

  // Paint the drawer straight from the add response, then refresh() confirms totals from Shopify a moment later.
  function showNow(added) {
    try {
      var c = JSON.parse(JSON.stringify(state.cart));
      added.forEach(function (it) {
        if (!it || !it.key) return;
        var i = -1; c.items.forEach(function (x, k) { if (x.key === it.key) i = k; });
        if (i > -1) { c.total_price += it.final_line_price - c.items[i].final_line_price; c.item_count += it.quantity - c.items[i].quantity; c.items[i] = it; }
        else { c.items.unshift(it); c.total_price += it.final_line_price; c.item_count += it.quantity; }
      });
      state.cart = c; render(); open();
    } catch (e) {}
  }

  function busy(btn, on) { el.classList.toggle('is-busy', on); if (btn) { btn.disabled = on; btn.classList.toggle('is-loading', on); } }
  function showErr(e) { var m = (e && e.message) || 'Something went wrong. Please try again.'; say(m); var b = $('[data-fc-body]'); var n = document.createElement('p'); n.className = 'fc__err'; n.textContent = m; b.prepend(n); setTimeout(function () { n.remove(); }, 4500); }

  function add(items, btn, source) {
    busy(btn, true);
    return api('cart/add.js', { items: items }).then(function (r) {
      (r.items || []).forEach(function (it) { trackAdd(it, source); });
      showNow(r.items || [r]);
      return refresh(true, true);
    }).catch(function (e) { showErr(e); throw e; }).then(function (c) { busy(btn, false); say('Added to cart'); return c; }, function (e) { busy(btn, false); throw e; });
  }
  function change(key, q, btn, extra) {
    busy(btn, true);
    var body = { id: key, quantity: q }; if (extra) for (var k in extra) body[k] = extra[k];
    return api('cart/change.js', body).then(function () { return refresh(false, true); }).catch(showErr).then(function () { busy(btn, false); });
  }

  // ---------- tracking (Klaviyo "Added to Cart" keeps abandoned-cart flows working) ----------
  function trackAdd(it, source) {
    try {
      var c = state.cart || { items: [] };
      var payload = {
        $value: (c.total_price || 0) / 100 + it.final_line_price / 100,
        AddedItemProductName: it.product_title, AddedItemProductID: it.product_id, AddedItemSKU: it.sku,
        AddedItemImageURL: it.image, AddedItemURL: location.origin + it.url, AddedItemPrice: it.final_price / 100, AddedItemQuantity: it.quantity,
        ItemNames: c.items.map(function (x) { return x.product_title; }).concat([it.product_title]),
        CheckoutURL: location.origin + ROOT + 'checkout', Source: source || 'fable-cart'
      };
      if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['track', 'Added to Cart', payload]);
    } catch (e) {}
    track('add_to_cart', { source: source || 'fable-cart', variant: it.variant_id, value: it.final_line_price / 100 });
  }
  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'fable_cart', fable_cart_action: name, fable_cart: data || {} }); } catch (e) {}
  }

  // ---------- events ----------
  el.addEventListener('click', function (e) {
    var t = e.target.closest('button, [data-fc-close], a'); if (!t) return;
    if (t.hasAttribute('data-fc-close')) return close();
    if (t.hasAttribute('data-fc-qty')) return change(t.getAttribute('data-fc-qty'), Math.max(0, +t.getAttribute('data-q')), t);
    if (t.hasAttribute('data-fc-add')) { add([{ id: +t.getAttribute('data-fc-add'), quantity: 1, properties: { _fable_cart_upsell: '1' } }], t, 'cart-upsell').catch(function () {}); return track('upsell_click', { variant: +t.getAttribute('data-fc-add') }); }
    if (t.hasAttribute('data-fc-mode')) { state.subMode = t.getAttribute('data-fc-mode'); return rerenderSub(); }
    if (t.hasAttribute('data-fc-subadd')) {
      var plan = +t.getAttribute('data-plan');
      add([{ id: +t.getAttribute('data-fc-subadd'), quantity: 1, selling_plan: plan, properties: { _fable_cart_upsell: t.getAttribute('data-mode') } }], t, 'cart-subscription').catch(function () {});
      return track('subscription_add', { mode: t.getAttribute('data-mode'), plan: plan });
    }
    if (t.hasAttribute('data-fc-setplan')) {
      var key = t.getAttribute('data-fc-setplan'), line = state.cart.items.filter(function (x) { return x.key === key; })[0]; if (!line) return;
      var p = t.getAttribute('data-plan');
      return change(key, line.quantity, t, { selling_plan: p ? +p : null });
    }
    if (t.hasAttribute('data-fc-checkout')) {
      track('checkout');
      var note = $('[data-fc-note]');
      // Re-check gifts against the live cart first (another tab or app may have changed it).
      var go = function () { var to = function () { location.href = ROOT + 'checkout'; }; load().then(syncGifts).then(to, to); };
      if (note && note.value !== (state.cart.note || '')) return api('cart/update.js', { note: note.value }).then(go, go);
      return go();
    }
    if (t.matches('a.fc__img, a.fc__name') && t.getAttribute('href') === '#') e.preventDefault();
  });
  el.addEventListener('change', function (e) {
    var s = e.target.closest('[data-fc-subpick]'); if (!s) return;
    state.subPick[s.getAttribute('data-fc-subpick')] = +s.value; rerenderSub();
  });
  var noteT = null;
  el.addEventListener('input', function (e) {
    if (!e.target.matches('[data-fc-note]')) return;
    clearTimeout(noteT); var v = e.target.value;
    noteT = setTimeout(function () { api('cart/update.js', { note: v }).then(function (c) { state.cart.note = c.note; }).catch(function () {}); }, 600);
  });
  el.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') return close();
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(el.querySelectorAll('.fc__panel a[href], .fc__panel button:not([disabled]), .fc__panel select, .fc__panel textarea, .fc__panel summary, .fc__panel iframe'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
  function rerenderSub() {
    var old = $('.fc__sub'); if (!old) return;
    var w = document.createElement('div'); w.innerHTML = renderSubCard(state.cart);
    var n = w.firstElementChild; if (n) old.replaceWith(n); else old.remove();
    var tab = $('.fc__seg [aria-selected="true"]'); tab && tab.focus();
  }

  // Header cart icon and /cart links open the drawer.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var a = e.target.closest('#cart-icon-bubble, a[href="' + ROOT + 'cart"], a[href="/cart"], [data-open-cart]'); if (!a || el.contains(a)) return;
    if (location.pathname === ROOT + 'cart') return;
    e.preventDefault(); refresh(true);
  });

  // Plain HTML add-to-cart forms (vault pages, landers): add in place instead of leaving for /cart.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || !f.getAttribute || el.contains(f)) return;
    var act = (f.getAttribute('action') || '').split('?')[0];
    if (!/\/cart\/add(\.js)?$/.test(act)) return;
    e.preventDefault();
    var btn = e.submitter || f.querySelector('[type="submit"]');
    var fd; try { fd = new FormData(f, e.submitter); } catch (x) { fd = new FormData(f); }
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    nativeFetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Fable-Cart': '1' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add to cart'); return j; }); })
      .then(function (j) { (j.items || [j]).forEach(function (it) { if (it && it.variant_id) trackAdd(it, 'form'); }); showNow(j.items || [j]); return refresh(true, true); })
      .catch(function (err) { refresh(true).then(function () { showErr(err); }); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  // Any other script that changes the cart (theme forms, Recharge, Rewards, Fable Live, PDP add buttons): refresh, and open on add.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && (init.headers['X-Fable-Cart'] || (init.headers.get && init.headers.get('X-Fable-Cart')));
    var p = nativeFetch(input, init);
    var m = !mine && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.exec(url.split('#')[0]);
    if (m) p.then(function (r) { if (r.ok) refresh(m[1] === 'add'); });
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this.__fc = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.exec(String(url).split('#')[0]); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this; if (x.__fc) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) refresh(x.__fc[1] === 'add'); });
    return xSend.apply(this, arguments);
  };

  // ---------- public API + compatibility ----------
  var api_ = {
    open: function () { return refresh(true); }, close: close, refresh: refresh,
    add: function (items, opts) { items = Array.isArray(items) ? items : [items]; return add(items.map(function (i) { return { id: +i.id, quantity: i.quantity || 1, properties: i.properties, selling_plan: i.selling_plan }; }), null, (opts && opts.source) || 'api'); },
    get cart() { return state.cart; }
  };
  window.FableCart = api_;
  window.openCart = function () { return api_.open(); };
  // Old CRO snippets call Monster's helper; keep them working.
  window.monster_addToCart = function (item, openIt) { return add([{ id: +item.id, quantity: item.quantity || 1, properties: item.properties }], null, 'pdp').then(function () { if (openIt === false) close(); return true; }); };
  // Dawn product form expects a <cart-drawer> with these methods.
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      renderContents() { refresh(true, true); }
      getSectionsToRender() { return []; }
      setActiveElement(x) { state.lastFocus = x; }
      open() { refresh(true); }
      close() { close(); }
    });
  }
  // Dawn's cart notification (if the theme is ever switched to it) opens our drawer instead.
  var CN = customElements.get('cart-notification');
  if (CN) { CN.prototype.renderContents = function () { refresh(true); }; CN.prototype.open = function () {}; }

  // First paint from the server-rendered cart, then make sure gifts are right.
  render();
  if (state.cart.item_count) syncGifts().then(function (changed) { if (changed) render(); });
})();
